@layer design-system {
  .readMoreButton {
    margin-left: 5px;

    &:focus {
      outline: none;
    }
  }
}
